import * as React from "react";

import { notify } from "@cayuse/shared-react.components.banner-notification";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { NotificationMessage } from "components/NotificationMessage";

import { CayuseError } from "./proxy";

export const notifyError = (message, error, options = {}) => {
	let meta = "";

	if (error instanceof CayuseError) {
		if (isNonEmptyString(error.meta.spRequestId)) {
			meta = `SP request id: ${error.meta.spRequestId}`;
		} else if (isNonEmptyString(error.meta.flowableDesignRequestId)) {
			meta = `Flowable design request id: ${error.meta.flowableDesignRequestId}`;
		} else if (isNonEmptyString(error.meta.flowableEngageRequestId)) {
			meta = `Flowable engage request id: ${error.meta.flowableEngageRequestId}`;
		}
	}

	if(error instanceof Object) {
		console.error(error, error.message, error.name, error.cause);
	}

	notify(
		<NotificationMessage
			message={message}
			meta={meta}
		/>,
		{ type: "error", ...options },
	);
};
